import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import defineConf from "../../config/defineConf";
import { getColumnNameArrayPerProcess, getProcessName } from "../../lib/TkPopUtils/TkPopProductMangeDetailUtils";

function TkPopWrappingUpdateButton(props) {

    const { t } = useTranslation();

    const { id, grid, mode, refresh, onSuccess, createButtonName, customizeErrorMsgCallback, detailSeletMst, processCode, shapeType, ...others } = props;

    const [open, setOpen] = useState(false);
    const [schema, setSchema] = useState(false);
    const [formData, setFormData] = useState();
    
    useEffect(() => {

        let schema = {

            name: "TkPopProductManageDetail",
            type: "BASE TABLE",
            searchAll: false,
            formGroups: [
                "disabled",
                "wrappingInput",
                "commonInput"
            ],

            columns: [
                { 
                    name: "planDetailId", 
                    key: "PRI",
                    formGroup: 0,
                    formOrder : 0,
                    disabled : true,
                    hideInForm: true,
                    formItemType : "text",
                },
                { 
                    name: "planId", 
                    formGroup: 0,
                    formOrder : 0,
                    disabled : true,
                    hideInForm: true,
                    formItemType : "text",
                },
                { 
                    name: "processCode", 
                    formGroup: 0,
                    formOrder : 10,
                    disabled : true,
                    hideInForm: true,
                    formItemType : "text",
                },
                { 
                    name: "wpShapeType", 
                    formGroup: 0,
                    formOrder : 20,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "workTime", 
                    formGroup: 2,
                    formOrder : 80,
                    disabled : false,
                    hideInForm : false,
                    formItemType: "autocompleteSolo",
                    codeInfo: {
                        tableName: "TimeToSecond",
                        nameColumn: ["timeName"],
                        valueColumn: "second",
                    }
                },
                { 
                    name: "workers",
                    formGroup: 2,
                    formOrder: 90,
                    disabled : false,
                    hideInForm : false,
                    formItemType: "multipleAutocomplete",

                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        useEmptyValue: false,
                        sortByName: true,
                    }
                },
                { 
                    name: "isRepair", 
                    formGroup: 2,
                    formOrder : 100,
                    disabled : false,
                    hideInForm : false,
                    formItemType : "checkbox",
                },
                { 
                    name: "size", 
                    formGroup: 2,
                    formOrder : 110,
                    disabled : false,
                    hideInForm : false,
                    formItemType: "select",

                    selectItems: [
                        {
                            name: "selectItems.size.big",
                            value: defineConf.sizeType.BIG
                        },
                        {
                            name: "selectItems.size.small",
                            value: defineConf.sizeType.SMALL
                        },
                        {
                            name: "selectItems.size.common",
                            value: defineConf.sizeType.COMMON
                        },
                    ],

                    defaultValue: defineConf.sizeType.SMALL,
                },
            ]

        };

        if(shapeType === "VD") {

            schema.columns.push (

                { 
                    name: "wpProduct", 
                    formGroup: 0,
                    formOrder : 30,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpDivision", 
                    formGroup: 0,
                    formOrder : 40,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpProductName", 
                    formGroup: 0,
                    formOrder : 50,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpSpec", 
                    formGroup: 0,
                    formOrder : 60,
                    disabled : true,
                    required: true,
                    formItemType: "text",
                },
                { 
                    name: "wpInch", 
                    formGroup: 1,
                    formOrder : 70,
                    required: true,
                    formItemType : "number",
                    validation : {
                        msg: "error.numberRequired",
                        type: "regexp",
                        value: "^[1-9][0-9]*$",
                    }
                },

            )

        } else {

            schema.columns.push(

                { 
                    name: "wpDivision", 
                    formGroup: 0,
                    formOrder : 30,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpArea", 
                    formGroup: 1,
                    formOrder : 40,
                    required: true,
                    formItemType : "number",
                    validation : {
                        msg: "error.numberRequired",
                        type: "regexp",
                        value: "^[1-9][0-9]*$",
                    }
                },
                { 
                    name: "wpSpec", 
                    formGroup: 1,
                    formOrder : 50,
                    required: true,
                    formItemType: "select",
                    sortByValue: true,
    
                    selectItems: [
                        {
                            name: "selectItems.wpSpec.lowUnitPrice",
                            value: defineConf.wpSpec.lowUnitPrice
                        },
                        {
                            name: "selectItems.wpSpec.mediumUnitPrice",
                            value: defineConf.wpSpec.mediumUnitPrice
                        },
                        {
                            name: "selectItems.wpSpec.highUnitPrice",
                            value: defineConf.wpSpec.highUnitPrice
                        },
                    ],
                },

            )

        }

        setSchema(schema);

    }, [shapeType]);

    const onOpen = () => {

        if(grid) {

            let selectData = { ...(grid.selectedItems[0]) }
            let returnObj = {};
            returnObj["processCode"] = processCode;
            for (let column in selectData) {
                if (column === "workerId") {
                    let workerArray = [];
                    let workerValues = selectData[column]?.split(",");
                    let workerName = selectData["workers"]?.split(",");
                    if (workerValues) {

                        for (let [index, value] of workerValues.entries()) {
                            workerArray.push({ name: workerName[index], value: value })
                        }
                    }

                    returnObj["workers"] = workerArray;
                }

                if (column === "planDetailId" || getColumnNameArrayPerProcess(processCode === "CAM" ? processCode : getProcessName(processCode)).includes(column)) {

                    if (column === "workers") {
                        continue;
                    }

                    if (column === "workTime") {
                        let hms = selectData[column];
                        if (hms) {

                            let hmsSplit = hms.split(':');
                            var seconds = (+hmsSplit[0]) * 60 * 60 + (+hmsSplit[1]) * 60 + (+hmsSplit[2]);
                            returnObj[column] = seconds || 1800;
                        }
                        continue;
                    }
                    returnObj[column] = selectData[column];
                }
            }
            setFormData({ ...(returnObj) });

        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        if(refresh) {

            refresh.refresh();

        }

    };

    return (

        <>
            <UpdateRecordButtonLayout id={id + "update-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id + "update-dialog"}
                mode={mode}
                formId={id + "update-form"}
                title={schema ? t(`dialog.title.${shapeType === "VD" ? "TkPopProductManageDetailWrappingVD" : "TkPopProductManageDetailWrapping"}.update`) : ""}
                schema={schema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkPopWrappingUpdateButton;

